import { useNavigate } from "react-router-dom";

// One-step-back navigation with a sensible fallback: mirrors browser back
// so the user's flow is preserved instead of always jumping Home.
export default function useSmartBack(fallback = "/") {
  const navigate = useNavigate();
  return () => {
    if (window.history.length > 1 && window.history.state?.idx > 0) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };
}
